import { setPublicPath } from "systemjs-webpack-interop";

setPublicPath("@prisma/share-module");